import { RedoShopifyDeliveryMethodType } from "@redotech/redo-fulfillment-group-common/fulfillment-delivery-method-type";
import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import TruckIcon from "@redotech/redo-icons/truck-02.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import { deliveryMethodText } from "../../common/delivery-method-badge";

const entry = fgFilterEntries.deliveryMethod;

export const DeliveryMethodFilter: ArrayStringTableFilter<string> = {
  type: entry.type,
  Icon: TruckIcon,
  operators: [...entry.operators],
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "delivery method",
  itemLabelPlural: "delivery methods",
  values: [...entry.staticValues],
  display: (item: string) => {
    return deliveryMethodText[item as RedoShopifyDeliveryMethodType];
  },
  displayName: entry.displayName,
};
